export default __webpack_public_path__ + "static/media/miezeBG.9ab86062.png";